import React, { useState, useEffect, useRef } from 'react';
import { GoogleMap, useJsApiLoader, StandaloneSearchBox } from '@react-google-maps/api';
import ProfDashboardLayout from './ProfDashboardLayout';
import { useFormik } from 'formik';
import { professionalProfileUpdateSchema } from '../../../schemas/profUserProfielSchema';
import { useDispatch, useSelector } from 'react-redux';
import { professionalUserUpdateAPI } from '../../../redux/slices/professionalUserUpdate';
import GoogelMapAPI from '../../../components/GoogelMapAPI/GoogelMapAPI';
import { base, errorHandler } from '../../../constants/base';
import { toast } from 'react-toastify';
import { updateUser } from '../../../redux/slices/authSlice';

const ProfProfile = () => {

    const [isEditable, setIsEditable] = useState(false);
    const dispatch = useDispatch();
    const loading = useSelector(state => state.professionalUserUpdateSlice.loading)
    const [getLocationAttributes, setGetLocationAttributes] = useState({})
    const [showProfileImage, setShowProfileImage] = useState("")

    const [profile, setProfile] = useState("")
    const [certificate, setCertificate] = useState("")
    const [other, setOther] = useState("")

    const userProfile = useSelector((state) => state.AuthSlice.user)
    const profileImage = userProfile?.images[0]?.path;
    const certificateImage = userProfile?.images[1]?.path;
    const otherImage = userProfile?.images[2]?.path;


    const formik = useFormik({
        initialValues: {
            id: userProfile?.id,
            name: userProfile?.name,
            email: userProfile?.email,
            address: userProfile?.address?.address,
            longitude: userProfile?.address?.longitude || '',
            latitude: userProfile?.address?.latitude || '',
            ss_number: userProfile?.ss_number,
            about: userProfile?.about,
            profile: null,
            certificate: null,
            other: null,
        },
        validationSchema: professionalProfileUpdateSchema,
        enableReinitialize: true,
        onSubmit: async (values) => {
            if (!isEditable) return;

            const formData = new FormData();
            formData.append('id', values.id);
            Object.keys(values).forEach((key) => {
                if (key === 'profile' && values.profile) {
                    formData.append('profile', values.profile);
                } else if (key === 'certificate' && values.certificate) {
                    formData.append('certificate', values.certificate);
                } else if (key === 'other' && values.other) {
                    formData.append('other', values.other);
                } else if (key !== 'id' && key !== 'profile' && key !== 'certificate' && key !== 'other') {
                    formData.append(key, values[key]);
                }
            });

            const res = await dispatch(professionalUserUpdateAPI(formData));

            if (professionalUserUpdateAPI.fulfilled(res)) {
                setIsEditable(false);
                if (res.payload.status === 200) {
                    toast.success('Profile updated successfully!');
                    dispatch(updateUser(res.payload.data.data))
                } else {
                    errorHandler(res.payload.errors);
                }
            } else if (professionalUserUpdateAPI.rejected(res)) {
                errorHandler(res.payload.errors);
                setIsEditable(false);
            } else {
                toast.error('Sorry, something went wrong!');
                setIsEditable(false);
            }
        },
    });


    const handleEdit = () => {
        setIsEditable(true);
    };

    // useEffect(() => {
    //     setProfile(profileImage);
    // }, [profileImage]);

    // const handleFileChange = (event, fieldName) => {
    //     const file = event.target.files[0];
    //     if (file) {
    //         if (fieldName === 'profile') {
    //             const previewUrl = URL.createObjectURL(file);
    //             // setProfile(file)
    //             setShowProfileImage(previewUrl);
    //         } else if (fieldName === 'certificate') {
    //             setCertificate(file);
    //         } else if (fieldName === 'other') {
    //             setOther(file);
    //         }
    //         formik.setFieldValue(fieldName, file);
    //     } else {
    //         if (fieldName === 'profile') {
    //             setProfile(null);
    //         } else if (fieldName === 'certificate') {
    //             setCertificate(null);
    //         } else if (fieldName === 'other') {
    //             setOther(null);
    //         }
    //     }
    // };

    const handleFileChange = (event, fieldName) => {
        const file = event.target.files[0];
        if (file) {
            if (fieldName === 'profile') {
                const previewUrl = URL.createObjectURL(file);
                setShowProfileImage(previewUrl);
            }
            formik.setFieldValue(fieldName, file);
        } else {
            formik.setFieldValue(fieldName, null);
        }
    };

    // GOOGLE API LOCATION
    const inputRef = useRef(null);
    const [coordinates, setCoordinates] = useState({ lat: null, lng: null });

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.REACT_APP_GOOGLEMAPS_API_KEY,
        libraries: ["places"]
    });

    const handlePlacesChange = () => {
        const places = inputRef.current.getPlaces();
        if (places && places?.length > 0) {
            const place = places[0];
            const lat = place.geometry.location.lat();
            const lng = place.geometry.location.lng();
            setCoordinates({ lat, lng });
            setGetLocationAttributes({
                address: places[0].formatted_address,
                longitude: lng,
                latitude: lat
            })
        }
    };
    // GOOGLE API LOCATION


    return (
        <ProfDashboardLayout>
            <div className="add-employee-box">
                <form className="my-profile-page-signup" onSubmit={formik.handleSubmit}>
                    {/* Full Name */}
                    <div className="mb-3 custom-input-box">
                        <input
                            type="text"
                            name="name"
                            className="form-control"
                            placeholder="Full Name"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            disabled={!isEditable}
                        />
                        {formik.touched.name && formik.errors.name && (
                            <div className="error">{formik.errors.name}</div>
                        )}
                    </div>

                    {/* Email */}
                    <div className="mb-3 custom-input-box">
                        <input
                            type="email"
                            name="email"
                            className="form-control"
                            placeholder="Email"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            disabled={true}
                        />
                    </div>

                    {/* Address */}
                    <div className="mb-3 custom-input-box">
                        {isLoaded && (
                            <StandaloneSearchBox
                                onLoad={(ref) => (inputRef.current = ref)}
                                onPlacesChanged={() => {
                                    const places = inputRef.current.getPlaces();
                                    if (places?.length > 0) {
                                        const address = places[0].formatted_address;
                                        formik.setFieldValue('address', address);
                                    }
                                }}
                            >
                                <input
                                    type="text"
                                    value={formik.values.address}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    disabled={!isEditable}
                                    className="form-control"
                                    name="address"
                                    placeholder="Enter your address"
                                />
                            </StandaloneSearchBox>
                        )}

                        {/* Optional: Show a message only if needed */}
                        {/* {formik.touched.address && formik.errors.address && (
                            <div className="error">{formik.errors.address}</div>
                        )} */}
                    </div>

                    {/* SSN */}
                    <div className="mb-3 custom-input-box">
                        <input
                            type="text"
                            name="ss_number"
                            className="form-control"
                            placeholder="Social Security Number"
                            value={formik.values.ss_number}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            disabled={!isEditable}
                        />
                        {formik.touched.ss_number && formik.errors.ss_number && (
                            <div className="error">{formik.errors.ss_number}</div>
                        )}
                    </div>

                    {/* About */}
                    <div className="mb-3 custom-input-box w-100">
                        <textarea
                            className="form-control"
                            name="about"
                            placeholder="About Yourself"
                            rows="3"
                            value={formik.values.about}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            disabled={!isEditable}
                        ></textarea>
                        {formik.touched.about && formik.errors.about && (
                            <div className="error">{formik.errors.about}</div>
                        )}
                    </div>

                    {/* Profile Picture */}
                    <div className="logo-box">
                        <h3 className="second-text-heading mt-0">Profile Picture</h3>
                        {/* {profile && ( */}
                        <img
                            // src={`http://54.173.195.14/storage/${profileImage}`}
                            src={showProfileImage || `${base.imageUrl}${profileImage}`}
                            alt="Profile"
                            className="uploaded-image"
                            style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                        />
                        {/* )} */}
                        <label htmlFor="profile" className="upload-image">
                            <span>Upload Image</span>
                        </label>
                        <input
                            type="file"
                            name="profile"
                            className="d-none"
                            id="profile"
                            onChange={(event) => handleFileChange(event, 'profile')}
                            disabled={!isEditable}
                        />
                    </div>

                    {/* Professional Certificate */}
                    <div className="logo-box" style={{ width: '235px' }}>
                        <h3 className="second-text-heading mt-0">Professional Certificate</h3>
                        {<p style={{ wordBreak: "break-all" }}><strong>Document Name:</strong> {formik?.values?.certificate?.name || certificateImage}</p>}
                        <label htmlFor="certificate" className="upload-image">
                            <span>Upload Document</span>
                        </label>
                        <input
                            type="file"
                            name="certificate"
                            className="d-none"
                            id="certificate"
                            onChange={(event) => handleFileChange(event, 'certificate')}
                            accept=".pdf,.doc,.docx"
                            disabled={!isEditable}
                        />
                    </div>

                    {/* Other Supporting Document */}
                    <div className="logo-box" style={{ width: '235px' }}>
                        <h3 className="second-text-heading mt-0">Other Supporting Document</h3>
                        {<p style={{ wordBreak: "break-all" }}><strong>Document Name:</strong> {formik?.values?.other?.name || otherImage}</p>}
                        <label htmlFor="other" className="upload-image">
                            <span>Upload Document</span>
                        </label>
                        <input
                            type="file"
                            name="other"
                            className="d-none"
                            id="other"
                            onChange={(event) => handleFileChange(event, 'other')}
                            accept=".pdf,.doc,.docx"
                            disabled={!isEditable}
                        />
                    </div>

                    <div className="submit-btn-form">
                        {isEditable ? (
                            <button
                                type="button"
                                disabled={loading}
                                onClick={formik.handleSubmit}
                                className="btn btn-primary ps-5 pe-5"
                            >
                                {!loading ? "Submit" : (
                                    <i
                                        style={{ fontSize: "22px" }}
                                        className="fa-solid fa-spinner fa-spin"
                                    ></i>
                                )}
                            </button>
                        ) : (
                            <button
                                type="button"
                                onClick={handleEdit}
                                className="btn btn-secondary ps-5 pe-5"
                            >
                                Edit
                            </button>
                        )}
                    </div>
                </form>
            </div>
        </ProfDashboardLayout>
    );
};

export default ProfProfile;